import { Breadcrumb, Flex, Button } from '@applyboard/crystal-ui';

import { PageHeader } from '~/components/PageHeader';
import { ChangeProgramTable, ProgramDetails } from '../components';
import { BreadcrumbItem } from '../types';
import { useApplication } from '~/context';
import {
  CampusFilter,
  IntakeFilter,
  IntakesFilterSummary,
  IntakesPagination,
  QueryFilter,
  Sort,
  StatusFilter,
} from '~/components/Intake';

type TabletLayoutProps = {
  breadcrumbItems: BreadcrumbItem[];
};

export function TabletLayout(props: Readonly<TabletLayoutProps>) {
  const { application } = useApplication();

  const handleCancel = () => {
    window.location.href = `/applications/${application.id}`;
  };

  return (
    <Flex p={10} gap={3} direction="column">
      <Breadcrumb items={props.breadcrumbItems} />
      <Flex justify="between" align="center">
        <PageHeader title="Change Primary Program Intake" />
        <Button intent="secondary" emphasis="outlined" onClick={handleCancel} width="hug">
          Cancel
        </Button>
      </Flex>
      <ProgramDetails lineSplit={false} />
      <Filter as={<QueryFilter />} width="100%" />
      <Flex gap={2}>
        <Filter as={<CampusFilter />} width="25%" />
        <Filter as={<IntakeFilter />} width="25%" />
        <Filter as={<StatusFilter />} width="25%" />
        <Filter as={<Sort showCreatedSort={false} />} width="25%" />
      </Flex>
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <ChangeProgramTable />
      <IntakesPagination />
    </Flex>
  );
}

type FilterProps = {
  as: React.ReactNode;
  width: string;
};

function Filter(props: Readonly<FilterProps>) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
